import { createFileRoute } from "@tanstack/react-router";
import { Home3D } from "@/pages/3d/Home3D";

export const Route = createFileRoute("/demo/3d/")({
  component: Home3D,
});
